import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import Logo from './Logo';
import LanguageSwitcher from './LanguageSwitcher';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <Logo size={44} light />
              <p className="footer__tagline">
                {t('footer.tagline')}
              </p>
              <div className="footer__contact-quick">
                <a href="tel:+919421722575" className="footer__contact-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.93 1.18 2 2 0 012.92 1h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L6.91 8.9A16 16 0 0015.1 17.1l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 17z"/></svg>
                  {t('footer.phone')}
                </a>
                <a href="mailto:shivshrienterprises2628@gmail.com" className="footer__contact-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                  {t('footer.email')}
                </a>
                <div className="footer__contact-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  {t('footer.location')}
                </div>
              </div>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">{t('footer.quickLinks')}</h4>
              <ul className="footer__nav">
                <li><Link to="/">{t('footer.home')}</Link></li>
                <li><Link to="/about">{t('footer.about')}</Link></li>
                <li><Link to="/services">{t('footer.ourServices')}</Link></li>
                <li><Link to="/why-us">{t('footer.whyChooseUs')}</Link></li>
                <li><Link to="/gem">{t('footer.gemPortal')}</Link></li>
                <li><Link to="/contact">{t('footer.contactUs')}</Link></li>
                <li><Link to="/terms">{t('footer.termsConditions') || 'Terms & Conditions'}</Link></li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">{t('footer.services')}</h4>
              <ul className="footer__nav">
                <li><Link to="/services">{t('footer.cctvInstallation')}</Link></li>
                <li><Link to="/services">{t('footer.dvrNvrSetup')}</Link></li>
                <li><Link to="/services">{t('footer.amc')}</Link></li>
                <li><Link to="/services">{t('footer.remoteMonitoring')}</Link></li>
                <li><Link to="/services">{t('footer.cameraRepair')}</Link></li>
                <li><Link to="/gem">{t('footer.gemSupplies')}</Link></li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__col-title">{t('footer.serviceAreas')}</h4>
              <ul className="footer__nav footer__areas">
                <li>{t('footer.gargoti')}</li>
                <li>{t('footer.kolhapurCity')}</li>
                <li>{t('footer.kagal')}</li>
                <li>{t('footer.chandgad')}</li>
                <li>{t('footer.gadhinglaj')}</li>
                <li>{t('footer.ajra')}</li>
                <li>{t('footer.bhudargad')}</li>
                <li>{t('footer.allKolhapur')}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Social Share Section */}
      <div className="footer__social">
        <div className="container">
          <div className="footer__social-inner">
            <h4 className="footer__social-title">{t('footer.shareWebsite') || 'Share Our Website'}</h4>
            <div className="footer__social-links">
              <a 
                href={`https://wa.me/?text=${encodeURIComponent('ShivShri Enterprises - Kolhapur CCTV Security Solutions - ' + window.location.origin)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-btn footer__social-btn--whatsapp"
                title="Share on WhatsApp"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp
              </a>
              <a 
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.origin)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-btn footer__social-btn--facebook"
                title="Share on Facebook"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                Facebook
              </a>
              <a 
                href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.origin)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-btn footer__social-btn--linkedin"
                title="Share on LinkedIn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                LinkedIn
              </a>
              <a 
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.origin)}&text=${encodeURIComponent('ShivShri Enterprises - Kolhapur CCTV Security Solutions')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-btn footer__social-btn--twitter"
                title="Share on X"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
                </svg>
                X
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-inner">
            <p>{t('footer.copyright')}</p>
            <div className="footer__bottom-right">
              <div className="footer__vocal-local">
                <span>🇮🇳</span>
                {t('footer.vocalForLocal') || 'Vocal for Local | Atmanirbhar Bharat'}
              </div>
              <LanguageSwitcher variant="footer" />
              <div className="footer__gem-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                {t('footer.gemBadge')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
